import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/trip/$tripId/traditional')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/trip/$tripId/itinerary',
      params: { tripId: params.tripId },
      search: { mode: 'timeline' },
    });
  },
});
